<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <no-access v-if="accessDenied" />
  <q-layout view="hHh Lpr lFf" v-else>
    <q-header bordered class="bg-white text-black rounded-borders">
      <q-toolbar class="bg-white text-black" style="margin: 0; padding: 10px 0; overflow: hidden" >
        <q-btn flat stretch icon="menu" v-if="loggedIn && currentAccount.isAdmin" @click="leftDrawerOpen = !leftDrawerOpen"></q-btn>
        <q-separator vertical inset style="margin: 0" v-if="loggedIn && currentAccount.isAdmin"></q-separator>        <!-- HIDE THE LINKS TO WEBSITE AND REPLACE WITH SEARCH, CART and LOGIN -->
        <div v-if="$q.screen.width < 920" style="width: 100%;">
          <!-- SHOW THE SEARCH BAR ON THE TOP NAV BAR IF BETTWEEN 600 and 1024PX -->
          <div v-if="$q.screen.width < 1024 && $q.screen.width > 600" style="display: inline; float: left" >
            <q-input outlined dense v-model="search" placeholder="Search" debounce="500" v-if="showingAHoldsStore">
              <template v-slot:append>
                <q-icon v-if="search === ''" name="search" />
                <q-icon v-else name="clear" class="cursor-pointer" @click="search = ''" />
              </template>
            </q-input>
            <q-space></q-space>
          </div>

          <div style="display: inline; float: right">
            <q-btn flat stretch icon="shopping_cart" @click="showdial">
            <q-badge  v-if="cartItemsQty" color="blue" floating>{{ cartItemsQty }}</q-badge>
          </q-btn>

          <account-access :storeType="storeType"></account-access>
          </div>


        </div>
        <div style="display: flex; justify-content: center; width: 100%;" v-else>
          <TopMenuBar />
        </div>
      </q-toolbar>
      <!-- Second Bar (Bottom) -->
      <q-toolbar class="second_bar" style="padding: 0; border-top: solid 1px silver; display: flex" v-if="$q.screen.width <= 600" >
        <div v-if="$q.screen.width <= 600" style="width: 100%; padding: 5px">
          <q-input
            outlined
            dense
            v-model="search"
            placeholder="Search"
            debounce="500"
            v-if="showingAHoldsStore"
          >
            <template v-slot:append>
              <q-icon v-if="search === ''" name="search" />
              <q-icon
                v-else
                name="clear"
                class="cursor-pointer"
                @click="search = ''"
              />
            </template>
          </q-input>
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore && storeType == 'retail'">
          <q-btn
            to="/"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore && storeType == 'stock'">
          <q-btn
            to="/stock"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore  && storeType == 'container'">
          <q-btn
            to="/container"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
      </q-toolbar>
      <q-toolbar class="second_bar" style="padding: 0; border-top: solid 1px silver; display: flex" v-if="$q.screen.width > 600 && $q.screen.width < 920 && !showingAHoldsStore"  >
        <div v-if="$q.screen.width <= 600" style="width: 100%; padding: 5px">
          <q-input
            outlined
            dense
            v-model="search"
            placeholder="Search"
            debounce="500"
            v-if="showingAHoldsStore"
          >
            <template v-slot:append>
              <q-icon v-if="search === ''" name="search" />
              <q-icon
                v-else
                name="clear"
                class="cursor-pointer"
                @click="search = ''"
              />
            </template>
          </q-input>
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore && storeType == 'retail'">
          <q-btn
            to="/"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore && storeType == 'stock'">
          <q-btn
            to="/stock"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore  && storeType == 'container'">
          <q-btn
            to="/container"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
      </q-toolbar>
      <q-toolbar class="second_bar" style="padding: 0; border-top: solid 1px silver; display: flex" v-if="$q.screen.width >= 920">
        <div id="left_back_btn" v-if="!showingAHoldsStore && storeType == 'retail'">
          <q-btn
            to="/"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore && storeType == 'stock'">
          <q-btn
            to="/stock"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div id="left_back_btn" v-if="!showingAHoldsStore  && storeType == 'container'">
          <q-btn
            to="/container"
            icon="arrow_back_ios_new"
            flat
            stretch
            style="align-self: flex-start; font-weight: bold; padding: 8px"
            >Back</q-btn
          >
        </div>
        <div v-if="$q.screen.width >= 920" id="search_on_second_bar" style="flex-grow: 4" >
          <q-input
            style="width: 100%; max-width: 500px; margin: auto"
            outlined
            dense
            v-model="search"
            placeholder="Search"
            debounce="500"
            v-if="showingAHoldsStore"
          >
            <template v-slot:append>
              <q-icon v-if="search === ''" name="search" />
              <q-icon
                v-else
                name="clear"
                class="cursor-pointer"
                @click="search = ''"
              />
            </template>
          </q-input>
        </div>
        <div v-if="$q.screen.width >= 920" id="access_btn_second_bar" style="min-width: 210px; max-width: 210px" >
          <q-btn style="float: left; padding: 10px 10px" stretch dense flat icon="shopping_cart" @click="showdial" v-model="getCartID" >
            <q-badge v-if="cartItemsQty" color="blue" floating>{{ cartItemsQty }}</q-badge>
          </q-btn>

          <account-access :storeType="storeType"></account-access>

        </div>
      </q-toolbar>
    </q-header>
    <q-drawer v-if="loggedIn && currentAccount.isAdmin" v-model="leftDrawerOpen" bordered content-class="bg-grey-2" :width="260" :breakpoint="500" show-if-above >
      <q-scroll-area style="height: calc(100% - 5px)">
        <q-list>
          <q-expansion-item :content-inset-level="0.25" icon="attach_money" label="Sales Dept." v-if="loggedIn && currentAccount.roles.includes('sales')" default-opened >
            <q-item to="/admin/sales/enquiries">
              <q-item-section avatar>
                <q-icon name="contacts" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Enquiries</q-item-label>
              </q-item-section>
            </q-item>
          </q-expansion-item>
          <q-expansion-item :content-inset-level="0.25" icon="verified_user" label="Admin" v-if="loggedIn && currentAccount.isAdmin" default-opened >
            <!-- <q-item to="/admin/dashboard" exact>
              <q-item-section avatar>
                <q-icon name="dashboard" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Dashboard</q-item-label>
              </q-item-section>
            </q-item> -->
            <q-item to="/admin/accounts">
              <q-item-section avatar>
                <q-icon name="people" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Accounts</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/group-orders" v-if=" loggedIn && currentAccount.roles.includes('containerStoreAccess') && currentAccount.roles.includes('brandOrderAccess') " >
              <q-item-section avatar>
                <q-icon name="group_work" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Group Orders</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/container-orders" v-if=" loggedIn && currentAccount.roles.includes('containerStoreAccess') " >
              <q-item-section avatar>
                <q-icon name="layers" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Factory Orders</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/stock-orders">
              <q-item-section avatar>
                <q-icon name="layers" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Stock Orders</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/retail-orders">
              <q-item-section avatar>
                <q-icon name="layers" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Retail Orders</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/email-templates">
              <q-item-section avatar>
                <q-icon name="email" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Email Templates</q-item-label>
              </q-item-section>
            </q-item>
            <q-expansion-item :content-inset-level="0.25" icon="work" label="Products" v-if="loggedIn && currentAccount.isAdmin" default-opened >
              <q-item to="/admin/importFromOrderForm">
                <q-item-section avatar>
                  <q-icon name="fact_check" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>OFA</q-item-label>
                </q-item-section>
              </q-item>
              <q-item to="/admin/stockManagement">
                <q-item-section avatar>
                  <q-icon name="rule" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Stock Management</q-item-label>
                </q-item-section>
              </q-item>
              <q-item to="/admin/products">
                <q-item-section avatar>
                  <q-icon name="search" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Search / Edit</q-item-label>
                </q-item-section>
              </q-item>
              <q-item to="/admin/add-stock" v-if=" loggedIn && currentAccount.roles.includes('addStockAccess') " >
                <q-item-section avatar>
                  <q-icon name="playlist_add" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Add Stock</q-item-label>
                </q-item-section>
              </q-item>
              <q-item to="/admin/download-stock-list">
                <q-item-section avatar>
                  <q-icon name="list_alt" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Stock List</q-item-label>
                </q-item-section>
              </q-item>
              <q-item to="/admin/import-export-products" v-if=" loggedIn && currentAccount.roles.includes('bulkProductsAccess') " >
                <q-item-section avatar>
                  <q-icon name="import_export" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Import/Export</q-item-label>
                </q-item-section>
              </q-item>
            </q-expansion-item>
            <q-expansion-item :content-inset-level="0.25" icon="palette" label="Colours(New)" v-if="loggedIn && currentAccount.isAdmin" default-opened >
              <q-item to="/admin/coloursTable">
                <q-item-section avatar>
                  <q-icon name="list_alt" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Colours List</q-item-label>
                </q-item-section>
              </q-item>
              <q-item to="/admin/add-colour" >
                <q-item-section avatar>
                  <q-icon name="playlist_add" />
                </q-item-section>
                <q-item-section>
                  <q-item-label>Add Colour</q-item-label>
                </q-item-section>
              </q-item>
            </q-expansion-item>
            <q-item to="/admin/colours">
              <q-item-section avatar>
                <q-icon name="palette" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Colours</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/backups" v-if="loggedIn && currentAccount.roles.includes('backupAccess')" >
              <q-item-section avatar>
                <q-icon name="restore" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Backups</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/vouchers" v-if=" loggedIn && currentAccount.roles.includes('viewAndEditVouchersRole') " >
              <q-item-section avatar>
                <q-icon name="local_offer" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Vouchers</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/xero" v-if="loggedIn && currentAccount.roles.includes('xeroAccess')" >
              <q-item-section avatar>
                <q-icon name="account_balance" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Xero</q-item-label>
              </q-item-section>
            </q-item>
            <q-item to="/admin/settings" v-if="loggedIn && currentAccount.roles.includes('editRetailStoreSettingsAccess') " >
              <q-item-section avatar>
                <q-icon name="settings" />
              </q-item-section>
              <q-item-section>
                <q-item-label>Settings (Stores)</q-item-label>
              </q-item-section>
            </q-item>
          </q-expansion-item>
        </q-list>
      </q-scroll-area>
    </q-drawer>
    <q-page-container style="margin: 0 ">
           <!-- CART SIDE BOX -->
      <q-dialog v-model="dial" position="right" style="overflow: none">
        <q-card class="column" style="overflow: hidden; background-color: #f5f5f5; height: 100%" >
        <!-- HEAD -->
          <div class="row items-center no-wrap" style="border-bottom: 1px silver solid; background-color: white" >
            <q-btn flat stack dense icon="close" color="primary" @click="dial = false" class="text-bold" style="padding: 5px; font-size: 12px" >Close</q-btn >
            <q-separator vertical inset />
            <div class="text-bold" style="margin-left: 20px; font-size: 16px">
              Cart Summary
            </div>
          </div>

      <!-- CONTENT SCROLL 1 -->

          <q-scroll-area class="col" style="width: 360px" v-show="!showBreakdown" >
            <div v-if="cartItems.length == 0" style="margin-top: 80px">
              <img src="../assets/empty_cart_small.png" style=" display: block; margin-left: auto; margin-right: auto; width: 200px; " />
            </div>
            <div v-else v-for="item in cartItems" :key="item.id" style="margin: 0px 12px" >
              <div class="row full-width" style=" background-color: white; font-size: 14px; margin: 0 0 5px 0; padding: 10px 0; " >
                <q-img dense :src="getThumbnailImage(item)" style=" margin-right: 8px; width: 46px; height: 46px; border: 1px solid silver; " contain >
                  <q-tooltip anchor="center right" self="center left" :offset="[10, 10]" transition-show="scale" transition-hide="scale" content-style="background: white; border: solid 1px black" >
                    <q-img dense :src="getImage(item)" style="width: 25vw; height: 25vw" contain />
                  </q-tooltip>
                </q-img>
                <div style="float: right">
                  <div style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 165px; height: 23px; " >
                    {{ item.sku.product.name }}
                    <q-tooltip>{{ item.sku.product.name }}</q-tooltip>
                  </div>
                  <div style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 165px; height: 23px; " >
                    {{ item.sku.product.attributes.brand }} - {{ item.sku.product.attributes.range }}
                  </div>
                </div>
                <div :style="{ float: 'right', margin: '8px 5px 0 0 ', border: '1px solid silver', width: '12px', height: '12px', backgroundColor: item.sku.options.colour.hex, }" ></div>
                <div>
                  <q-input mask="####" :min="0" debounce="500" id="cu" class="cui" v-model="item.qty" maxlength="4" dense outlined input-style="font-weight:bold; text-align:center; width: 35px; margin:0; padding: 0" >
                    <template v-slot:prepend>
                      <q-btn class="minusButton" size="10px" @click="removeOne(item)" color="black" stretch flat icon="remove" style="width: 25px; height: 30px; margin-left: -12px" />
                    </template>
                    <template v-slot:append>
                      <q-btn class="plusButton" size="10px" @click="addOne(item)" color="black" stretch flat icon="add" style="width: 25px; height: 30px; margin-right: -12px" />
                    </template>
                  </q-input>
                  <div style="width:100%; margin-left: 38px;" v-if="findSkuError(item)">
                    <q-icon class="blink_me" size="large" name="warning" color="red"/>
                      <q-tooltip content-style="font-size: 14px; font-weight:bold; background: red;" anchor="top middle" self="center middle">
                        {{getUserFriendlyErrorMessage(findSkuError(item))}}
                      </q-tooltip>
                    </div>
                </div>
              </div>
            </div>
          </q-scroll-area>
      <!-- END CONTENT SCROLL 1 -->
          <!-- Bootom box -->

          <!-- BTN BREAKDOWN -->
          <div class="text-bold text-center" style="background-color: white; border-top: 1px solid silver" >
            <q-btn no-caps class="full-width" :icon-right="arrows" :icon="arrows" dense flat label="Items Breakdown" padding="0" @click="breakdownToggle" ></q-btn>
          </div>
<q-scroll-area class="col" style="width: 360px" v-show="showBreakdown">
            <!-- <q-card v-show="showBreakdown" style="background-color: ; " > -->
              <div v-if="cartItems.length > 0" style="border-top: 1px solid silver; padding: 10px 0">
                <summary-table style="margin: 0 10px" title="Brand" :items="cart.items" :hideTitle="true" :hidePriceColumn="true" store-type="retail" />
                <summary-table style="margin: 5px 10px 0 10px" title="Colour" :items="cart.items" :hideTitle="true" store-type="retail" :hidePriceColumn="true" :group-field-callback=" (row) => getNestedFieldInObject('sku.options.colour.group', row) " >
                  <template v-slot:group="props">
                    <div :style="{ border: '1px solid silver', backgroundColor: getNestedFieldInObject( 'row.item.sku.options.colour.hex', props ), width: '10px', height: '10px', }" class="inline-block" ></div>
                    {{ props.row.group }}
                  </template>
                </summary-table>
                <summary-table style="margin: 5px 10px 0 10px" title="Type" :items="cart.items" :hideTitle="true" :hidePriceColumn="true" store-type="retail" />
              </div>
            <!-- </q-card> -->
</q-scroll-area>

          <div class="row full-width" style=" height: 60px; background-color: white; border-top: 1px silver solid; " >
            <div style="width:30%; margin-top: 8px; background-color: ">
              <span class="text-center text-bold" style="display: block; font-size: 12px" >Subtotal</span>
              <div v-if="storeType == 'stock' && storeDiscount != 1">
                <span class="text-center text-bold" style="display: block; font-size: 16px" >${{ Number(totalCostOfItems * storeDiscount).toFixed(2) }}</span>
              </div>
              <div v-else>
                <span class="text-center text-bold" style="display: block; font-size: 16px" v-if="storeType == 'container'">${{ Number(Number(totalCostOfItems)/1.10).toFixed(2) }}</span>
                <span class="text-center text-bold" style="display: block; font-size: 16px" v-else>${{ Number(totalCostOfItems).toFixed(2) }}</span>
              </div>
            </div>
            <q-separator vertical inset></q-separator>
            <div style="width:20%; margin-top: 8px; background-color: ">
              <span class="text-center text-bold" style="display: block; font-size: 12px" >Holds</span>
              <span class="text-center text-bold" style="display: block; font-size: 16px" >{{ totalHolds }}</span>
            </div>
            <q-separator vertical inset></q-separator>
            <div style="width:20%; margin-top: 8px; background-color: ">
              <span class="text-center text-bold" style="display: block; font-size: 12px" >Sets</span>
              <span class="text-center text-bold" style="display: block; font-size: 16px" >{{ totalSets }}</span>
            </div>
            <div style="margin-top: 12px; margin-left:10px; background-color: ">
              <q-btn :to="cartRoute" dense color="primary" label="Checkout"></q-btn>
            </div>
          </div>
        </q-card>
      </q-dialog>

      <!-- CART SIDE BOX END -->

      <!-- <span style="display:none">THE VIEW GOES HERE</span> -->
      <no-network v-if="noNetworkConnection" />
      <div v-else>
        <div style="display: flex">
          <div style="flex: 1; background-color: #f5f5f5"><router-view /></div>
        </div>
      </div>
    </q-page-container>
  </q-layout>
</template>

<script>
import gql from 'graphql-tag'
import MPopupEdit from '../components/ui/MPopupEdit'
import MEditItem from '../components/ui/admin/MEditItem'
import SummaryTable from '../components/summaryTable'
import getNestedFieldInObject from '@/util/getNestedFieldInObject'
import { colourToString, formatCurrency, properCase } from '../util/string'
import store from '../store'

import ProductFilters from '../components/ProductFilters'
import EditCartMenu from '../components/EditCartMenu'
import NoNetwork from '../views/errors/NoNetwork'
import NoAccess from '../views/errors/NoAccess'
import AccountAccess from '../components/ui/AccountAccess'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { ref } from 'vue'

import TopMenuBar from '../components/TopMenuBar'

export default {
  name: 'LayoutDefault',
  components: {
    FontAwesomeIcon,
    EditCartMenu,
    ProductFilters,
    NoNetwork,
    NoAccess,
    // LoginOpen,
    MPopupEdit,
    MEditItem,
    SummaryTable,
    AccountAccess,
    TopMenuBar
  },
  // Cart_LMI_START
  apollo: {
    validateCart () {
      return {
        query: gql`query validateCart ($cartId: ID!) {
            validateCart (id: $cartId)
        }`,
        variables () {
          return {
            cartId: this.getCartID
          }
        },
        context: {
          headers: {
            uuid: this.currentUUID
          }
        },
        skip: () => !this.getCartID,
        fetchPolicy: 'network-only',
        async result (result) {
          // Clear all warnings
          if (result.data?.validateCart === true) this.cartErrors = []
        },
        error (error) {
          // Error is stored in a rather confusing structure.  See if future apollo updates break this... :(
          const parentCartValidationError = error.graphQLErrors?.find(v => v.extensions?.exception?.name === 'CartValidationErrors')?.extensions?.exception || {}
          this.cartErrors = parentCartValidationError?.errors || []
        }
      }
    },
    cart () {
      return {
        query: gql`
          query cart($id: ID!) {
            cart(id: $id) {
              id
              name
              notes
              items {
                id
                skuId
                qty
                sku {
                  id
                  stock
                  retailPrice
                  containerPrice
                  price
                  attributes
                  options
                  product {
                    id
                    name
                    images {
                      url
                      name
                    }
                    attributes
                    urlSlug
                  }
                }
              }
            }
          }
        `,
        variables () {
          return {
            id: this.getCartID
          }
        },
        update: (data) => data.cart,
        async result ({ data }) {
          try {
            await this.$apollo.queries.validateCart.refetch()
          } catch (ex) {
          }
          return data.cart
        },
        context: {
          headers: {
            uuid: this.currentUUID
          }
        },
        skip: () => !this.getCartID,
        fetchPolicy: 'network-only',
        error (error) {
          if (
            error.message ===
            `GraphQL error: Cart with id ${this.getCartID} does not exist.`
          ) {
            // createNewActiveCart
          }
        }
      }
    }
  },
  // Cart_LMI_END
  data () {
    let showFullScreenMenu = ref(false);
    let showingAHoldsStore = ref(false);

    return {
      storeType: null,
      showBreakdown: false,
      leftDrawerOpen: true,
      leftDrawMini: true,
      showingAHoldsStore,
      cartMenuShowing: true,
      cartErrors: [],
      details: { cartId: this.getCartID },
      dial: false,
      persistentLink: true,
      showFullScreenMenu

    }
  },
  computed: {
    storeDiscount () {
      if (this.storeType === 'stock') {
        return (100 - this.$store.state.auth.storeSettings.stockStoreDiscount) / 100
      } else {
        return 1
      }
    },
    persistent () {
      return true
    },
    cartItemsQty () {
      if (this.storeType == 'retail') return this.$store.state.cart.cartRetailQty
      if (this.storeType == 'stock') return this.$store.state.cart.cartStockQty
      if (this.storeType == 'container') return this.$store.state.cart.cartContainerQty
    },
    arrows () {
      if (!this.showBreakdown) {
        return 'expand_less'
      } else {
        return 'expand_more'
      }
    },
    totalCostOfItems () {
      if (this.storeType == 'retail') return (this.cart?.items || []).reduce((p, c, i) => p + (c.sku?.retailPrice || 0) * Number(c.qty), 0)
      if (this.storeType == 'stock') return (this.cart?.items || []).reduce((p, c, i) => p + (c.sku?.price || 0) * Number(c.qty), 0)
      if (this.storeType == 'container') return (this.cart?.items || []).reduce((p, c, i) => p + (c.sku?.containerPrice || 0) * Number(c.qty), 0)
    },
    cartRoute () {
      return `/${this.storeType}/cart`
    },
    cartItems () {
      return this.cart ? this.cart.items : []
    },
    currentUUID () {
      return this.$store.state.auth.currentUUID
    },
    getCartID () {
      let id
      if (!!this.currentAccount && this.storeType == 'retail') {
        id = this.$store.state.auth.currentAccount?.activeRetailCartId
      } else if (!(this.currentAccount) && this.storeType == 'retail') {
        id = this.$store.state.auth.currentGuest.activeRetailCartId
      } else if (!!this.currentAccount && this.storeType == 'stock') {
        id = this.$store.state.auth.currentAccount?.activeCartId
      } else if (!!this.currentAccount && this.storeType == 'container') {
        id = this.$store.state.auth.currentAccount?.activeContainerCartId
      }
      return id
    },
    cartForLogin () {
      let data = {
        details: {
          cartId: this.getCartID
        }
      }
      return data
    },
    loggedIn () {
      return !!this.currentAccount
    },
    isAdmin () {
      if (this.currentAccount) {
        return this.currentAccount.isAdmin
      }
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    noNetworkConnection () {
      return this.$store.state.auth.noNetworkConnection
    },
    accessDenied () {
      return this.$store.state.auth.accessDenied
    },
    getName () {
      return this.$store.state.auth.currentAccount.contactName
    },
    getEmail () {
      return this.$store.state.auth.currentAccount.email
    },
    totalSets () {
      return this.cart?.items?.reduce((p, c, i) => p + Number(c.qty), 0)
    },
    totalHolds () {
      return (this.cart?.items || []).reduce(
        (p, c, i) => p + (c.sku?.product?.attributes?.holds || 0) * Number(c.qty),
        0
      )
    },
    search: {
      get () {
        return this.$store.state.filters.search
      },
      set (val) {
        if (val != '') {
          // Tracker
          analytics.track('Search', {
            term: val,
            storeType: this.$store.state.cart.currentStoreType
          })
        }
        this.$store.commit('filters/setSearch', val)
      }
    }
  },
  methods: {

    findSkuError (item) {
      return this.cartErrors.find(e => e.skuId === item.sku?.id)
    },
    getThumbnailImage (item) {
      return this.getImage(item) + '.png.thumb'
    },
    getImage (item) {
      return item.sku?.product?.images?.[0]?.url
    },
    breakdownToggle () {
      this.showBreakdown = !this.showBreakdown
    },
    getNestedFieldInObject: getNestedFieldInObject,
    getProductAttributeFromRow (attributeName, row) {
      return (
        this.getNestedFieldInObject(
          `sku.product.attributes.${attributeName}`,
          row
        ) || []
      )
    },
    colourToString: colourToString,
    findSkuError (row) {
      return this.cartErrors.find((e) => e.skuId === row.sku?.id)
    },
    addOne (item) {
      let qty = Number(item.qty)

      if (this.storeType == 'container') {
        item.qty++
        this.editCartItemQty(item, item.qty)
      } else {
        if (qty + 1 <= item.sku.stock) {
          item.qty++
          this.editCartItemQty(item, item.qty)
        } else {
        }
      }
    },
    removeOne (item) {
      let qty = Number(item.qty)

      if (qty - 1 >= 0) {
        item.qty--
        this.editCartItemQty(item, item.qty)
      }
    },
    editCartItemQty (row, qty) {
      qty = Number(qty)
      if (qty <= 0) {
        this.deleteCartItem(row?.id)
        // this.deleteCartItemWithConfirmation(row?.id);
      } else {
        this.editCartItem(row?.sku?.id, { qty })
      }
    },
    async editCartItem (skuId, updates) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation editItemInCart(
              $cartId: ID!
              $skuId: ID!
              $input: CartItemInput!
            ) {
              editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
                id
                name
                notes
                items {
                  id
                  skuId
                  qty
                  sku {
                    id
                    stock
                    retailPrice
                    attributes
                    options
                    product {
                      id
                      name
                      images {
                        url
                        name
                      }
                      attributes
                      urlSlug
                    }
                  }
                }
              }
            }
          `,
          variables: {
            cartId: this.getCartID,
            skuId: skuId,
            input: updates
          },
          context: {
            headers: {
              uuid: this.currentUUID
            }
          }
        })
        // eslint-disable-next-line no-undef
        analytics.track('Edit Item In Cart', {
          storeType: this.$store.state.cart.currentStoreType,
          cartId: this.getCartID,
          skuId,
          updates
        })
      } catch (error) {
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.$store.commit(`cart/setCart${properCase(this.storeType)}Qty`, this.totalSets)
    },
    deleteCartItemWithConfirmation (skuId) {
      this.$q
        .dialog({
          title: 'Remove',
          message: 'Are you sure you want to remove this item from your cart?',
          cancel: true,
          persistent: true
        })
        .onOk(() => {
          this.deleteCartItem(skuId)
        })
    },
    async deleteCartItem (itemId) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation deleteItemFromCartByItemId($cartId: ID!, $itemId: ID!) {
              deleteItemFromCartByItemId(id: $cartId, itemId: $itemId) {
                id
                name
                notes
                items {
                  id
                  skuId
                  qty
                  sku {
                    id
                    stock
                    retailPrice
                    attributes
                    options
                    product {
                      id
                      name
                      images {
                        url
                        name
                      }
                      attributes
                      urlSlug
                    }
                  }
                }
              }
            }
          `,
          variables: {
            cartId: this.getCartID,
            itemId
          },
          context: {
            headers: {
              uuid: this.currentUUID
            }
          }
        })
        // eslint-disable-next-line no-undef
        analytics.track('Delete Item From Cart', {
          storeType: this.$store.state.cart.currentStoreType,
          cartId: this.getCartID,
          where: 'cart',
          itemId
        })
      } catch (err) {
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.$store.commit(`cart/setCart${properCase(this.storeType)}Qty`, this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0))
      await this.$apollo.queries.cart.refetch()
    },

    openURL (address) {
      window.open(address, '_self')
    },
    async showdial () {
      analytics.track('Clicked Cart Button', {
        cartId: this.getCartID,
        where: 'cart',
        storeType: this.$store.state.cart.currentStoreType
      })
      this.showBreakdown = false
      await this.$apollo.queries.cart.refetch()
      if (this.dial) {
        this.dial = false
      } else {
        this.dial = true
      }
    },
    logout () {
      this.$q
        .dialog({
          title: 'Log Out',
          message: `Are you sure you want to log out?`,
          cancel: true
        })
        .onOk(() => {
          this.$store.dispatch('auth/logout', null)
          // eslint-disable-next-line no-undef
          analytics.track('Logout')
          if (this.$route.path.includes('retail')) {
            this.$router.push('/home').catch(() => {})
          } else {
            this.$router.push('/retail')
          }
        })
    },
    getMiniState () {
      return (
        this.leftDrawMini &&
        !this.$route.fullPath.startsWith('/account') &&
        !this.$route.fullPath.startsWith('/admin')
      )
    },
    isShowingAHoldsStore () {
      return (
        this.$route.path === '/stock/table' ||
        this.$route.path === '/stock/grid' ||
        this.$route.path === '/container/table' ||
        this.$route.path === '/container/grid' ||
        this.$route.path === '/retail/table' ||
        this.$route.path === '/retail/grid'
      )
    },
    getStoreType () {
      let type = this.$store.state.cart.currentStoreType

      if (this.$route.path.includes('retail')) type = 'retail'
      else if (this.$route.path.includes('stock')) type = 'stock'
      else if (this.$route.path.includes('container')) type = 'container'
      store.commit('cart/setCurrentStoreType', type)
      this.storeType = type

      return type
    },
    getUserFriendlyErrorMessage (error) {
      if (error.name === 'NotEnoughStockError') {
        if (!error.available) return `${error.available} items in stock`
        return `Only ${error.available} items in stock`
      }
      if (error.name === 'SkuDoesNotExistError') {
        return `Sku does not exist.`
      }
      if (error.name === 'SkuNotAvailableError') {
        return `This items is not available`
      }
    }
  },

  mounted () {
    this.showingAHoldsStore = this.isShowingAHoldsStore()
    // let spt = document.createElement('script')
    // spt.setAttribute('src', 'https://bpi.humm-au.com/au/content/scripts/price-info_sync.js?productPrice=10000.99&merchantId=30145341')
    // spt.setAttribute('src', 'https://widgets.shophumm.com.au/content/scripts/more-info-large.js')
    // document.getElementById("humm").appendChild(spt);
  },
  updated () {
    this.showingAHoldsStore = this.isShowingAHoldsStore()
    this.getStoreType()
  }
}
</script>

<style>
.menu-button {
  background-color: #f2f3f5;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  color:#434549;
  font-size: 24px;
  transition: 0.4s;
}

.menu-button:hover {
  background-color: #434549;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  color:#f2f3f5;
  font-size: 24px;
  transition: 0.4s;
}

.menuInner {
  min-height: calc(100vh - 84px)
}

.menuItem {
  color: #C4C5C6;
  font-weight: 500;
  font-size: 20px;
  height: 54px;
}

.menuItem:hover {
  color: #434549;
}

.closeIcon:hover {
  color: #c5161c;
  cursor: pointer;
}

</style>

<style scoped lang="stylus">
@import '~quasar-variables';

.q-toolbar {
  .q-d {
    min-width: 240px;
    max-width: 450px;
    margin: auto;
    box-sizing: border-box;
  }

  .search_mobs {
    min-width: 240px;
    max-width: 650px;
    width: 100%;
    background-color: red;
  }
}

.q-header {
  .q-avatar.main-logo {
    width: 80px;
    height: 80px;

    @media (max-width: 920px) {
      width: 45px;
      height: 45px;
      margin: 0px 10px;
    }
  }
}

>>> .q-stepper__dot:after {
  width: 0px;
}

>>> .cui .q-field__control {
  max-height: 30px;
}

>>> .cui .q-field__native {
  max-height: 30px;
}

>>> .cui .q-field__control:after {
  max-height: 30px;
}

>>> .minusButton .q-icon {
  margin-left:-6px
  margin-top:2px
}

>>> .plusButton .q-icon {
  margin-left:-6px
  margin-top:2px
}

.blink_me {
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.1;
  }

}

.box1{
  width:266px;
  height:266px;
  padding:10px;

}

.innerBox{
  width: 100%;
  height: 100%;
  background-color: grey;
}

.second_bar {
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: 601px) {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
